import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import getBaseUri from '../utils/getBaseUri'; // Import the base URI function
import { Transition } from '../components/Transition/Transition';

const SinglePost = () => {
    const { id } = useParams(); 
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await axios.get(`${getBaseUri()}/wp-json/wp/v2/posts/${id}`); // Use base URI
                setPost(response.data);
            } catch (error) {
                console.error('Error fetching the post:', error);
                setPost(null);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [id]);

    if (loading) {
        return <p>Loading post...</p>;
    }

    if (!post) {
        return <p>Post not found.</p>;
    }

    return (
        <Transition  className="single-post">
            <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
            <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
        </Transition>
    );
};

export default SinglePost;
